import "../design/tokens.css";
import "../design/global.css";
import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { AgencyApp } from "./App.tsx";

const app = document.getElementById("app");
if (!app) throw new Error("agencia.html has no #app element");
createRoot(app).render(
  <StrictMode>
    <Suspense>
      <AgencyApp />
    </Suspense>
  </StrictMode>,
);
